import { render } from "./ImageSize.vue?vue&type=template&id=25ed9a17"
import script from "./ImageSize.vue?vue&type=script&lang=js"
export * from "./ImageSize.vue?vue&type=script&lang=js"
script.render = render

export default script